import React from 'react';

import ComponentTypesIconWrapper from '../../../components/componentTypesIcon/ComponentTypesIconWrapper';
import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';
import ICONS from '../../../constants/icons';

interface RecommendationListItemProps {
    labelNameX: string;
    labelNameY: string;
    componentDataKeyX?: string;
    componentDataKeyY?: string;
    onClick: () => void;
}

const RecommendationListItem = ({
    labelNameX,
    labelNameY,
    componentDataKeyX,
    componentDataKeyY,
    onClick,
}: RecommendationListItemProps) => {
    return (
        <RowButton onClick={onClick}>
            <ItemTextWrap>
                <RowIcon>
                    <ComponentTypesIconWrapper dataKey={componentDataKeyX} />
                </RowIcon>
                <LabelPair>{labelNameX}</LabelPair>
            </ItemTextWrap>

            <ComponentPair>
                <ICONS.simpleSuffleLight
                    color={aampeTheme.colors.textAccessibleWG01}
                />
            </ComponentPair>

            <ItemTextWrap>
                <RowIcon>
                    <ComponentTypesIconWrapper dataKey={componentDataKeyY} />
                </RowIcon>
                <LabelPair>{labelNameY}</LabelPair>
            </ItemTextWrap>
            <RowIcon>
                <ICONS.compactRightArrow />
            </RowIcon>
        </RowButton>
    );
};

export default RecommendationListItem;

export const RowButton = styled.button(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(1),
    border: 'none',
    borderBottom: `1px solid ${aampeTheme.colors.bordersWG01}`,
    background: 'transparent',
    borderRadius: 0,
    padding: `${aampeTheme.spacing(2)} ${aampeTheme.spacing4(6)}`,
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background-color 120ms ease, border-color 120ms ease',
    width: '100%',
    '&:hover': {
        backgroundColor: aampeTheme.colors.gray50,
    },
    '&:focus-visible': {
        outline: `1px solid ${aampeTheme.colors.blue500}`,
        outlineOffset: 2,
    },
}));

export const ItemTextWrap = styled.div(() => ({
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
}));

export const LabelPair = styled.p(() => ({
    color: aampeTheme.colors.gray950,
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.medium,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
}));

export const ComponentPair = styled.span(() => ({
    color: aampeTheme.colors.solidWG02,
    fontSize: aampeTheme.size.font.textMedium,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 28,
}));

export const RowIcon = styled.span(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    flexShrink: 0,
}));
